// extracted by mini-css-extract-plugin
export default {"accountStatementWrapper":"AccountStatement_accountStatementWrapper__Tz3OA"};